import { Component, Input, OnInit, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';

import { NavbarVerticalStyle1Component } from '../style-1/style-1.component';

@Component({
    selector: 'fuse-vertical-dynamic',
    templateUrl: './style-dynamic.component.html',
    styleUrls: ['./style-dynamic.component.scss'],
    standalone: false
})
export class FuseNavbarVerticalComponentDynamic implements OnInit {
    @Input() public RefVerticalNavbarStyleComponent: any;

    constructor(
        private vcr: ViewContainerRef,
        private cfr: ComponentFactoryResolver
    ) {}

    ngOnInit() {
        if (this.RefVerticalNavbarStyleComponent) {
            this.vcr.createComponent(this.RefVerticalNavbarStyleComponent);
        } else {
            let myComp = this.cfr.resolveComponentFactory(NavbarVerticalStyle1Component);
            this.vcr.clear();
            this.vcr.createComponent(myComp);
        }
    }
}
